import ConfigureThree from "@/components/page/configure/ConfigureThree.vue"
import EleDataChart from "@/components/page/configure/EleDataChart.vue"
import EleDetail from "@/components/page/configure/EleDetail.vue"
import EleState from "@/components/page/configure/EleState.vue"
import EleTemperature from "@/components/page/configure/EleTemperature.vue"
import DialogEcharts from "@/components/page/configure/DialogEcharts.vue"
import WinDialog from "@/components/page/configure/WinDialog.vue"
import WinDialogNew from "@/components/page/configure/WinDialogNew.vue"
import WinVideo from "@/components/page/configure/video.vue"
import threeText from "@/components/page/configure/threeText.vue"
export default {
  ConfigureThree,
  EleDataChart,
  EleDetail,
  EleState,
  EleTemperature,
  DialogEcharts,
  WinDialog,
  WinVideo,
  threeText,
  WinDialogNew
}
